import { useMemo } from 'react';
import { IconMinus } from '@tabler/icons-react';
import { TransitionType } from '@/App/remotion/MainPlayer/types/Animations/Transitions/Transitions.types';
import { TransitionConfig } from '@/App/remotion/MainPlayer/types/Animations/Transitions/Transitions.constants';
import SelectDropdownV2 from '@/components/atoms/SelectDropdownV2';
import { classnames } from '@/libs/utils';

const iconSize = 16;

export const TransitionTypeDropdown = ({
  selected,
  onChange,
  disabled
}: {
  selected: TransitionType | null;
  onChange: (selected: TransitionType | null) => void;
  disabled: boolean;
}) => {
  const options = useMemo(() => {
    return [
      { value: null, label: 'None', Icon: <IconMinus size={iconSize} className="text-slate-400" /> },
      ...Object.values(TransitionType).map((type: TransitionType) => {
        const Icon = TransitionConfig[type].Icon;
        return {
          value: type,
          label: TransitionConfig[type].label,
          Icon: <Icon size={iconSize} className="text-slate-400" />
        };
      })
    ];
  }, []);

  return (
    <div className={classnames('mt-2.5 flex flex-1 flex-col', disabled ? 'cursor-not-allowed' : '')}>
      <SelectDropdownV2 options={options} selected={selected} onChange={onChange} disabled={disabled} />
    </div>
  );
};
